<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu  :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="list">框架协议列表</el-menu-item>
		  <el-menu-item index="list2">创建框架协议</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
		  <accordList v-if="activeIndex == 'list'"></accordList>
		  <addAccord v-if="activeIndex == 'list2'"></addAccord>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import accordList from "./accordList/list.vue";
import addAccord from "./addAccord/addForm.vue";
export default {
  data() {
    return {
      activeIndex: "list",
      queryData: {},
    };
  },
  components: {
	accordList,addAccord
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
    handleSelect(key, keyPath) {
		console.log(key, keyPath)
      this.activeIndex = key;
    },
    dealToContractList() {
      this.activeIndex = "list";
    },
  },
};
</script>